<template>
  <div id="sidebar-menu">
    <ul class="sidebar-links custom-scrollbar custom-scrollbar-hide" id="myDIV" :style="[
      layoutobject.split(' ').includes('horizontal-wrapper') ? layout.settings.layout_type == 'rtl' ? { '  -right': margin + 'px' } : { 'margin-left': margin + 'px' } : { margin: '0px' },
    ]">
      <li class="back-btn">
        <div class="mobile-back text-right">
          <span>Back</span> <i class="fa fa-angle-right pl-2" aria-hidden="true"></i>
        </div>
      </li>
      <li class="menu-box">
        <ul>
          <li v-for="(menu, index) in menuItems" :key="index" class="sidebar-list">
         
            <label :class="'badge badge-' + menu.badgeType" v-if="menu.badgeType">{{ menu.badgeValue }}</label>
            <a href="javascript:void(0)" :class="{ active: menu.active }" class="sidebar-link sidebar-title"
              v-if="menu.type == 'sub'" @click="setNavActive(menu, index)">
              <vue-feather :type="menu.icon" class="top"></vue-feather>
              <span>
                {{ $t(menu.title) }}
              </span>
              <div class="according-menu" v-if="menu.children">
                <i class="pull-right" :class="[menu.active ? 'fa fa-angle-down' : 'fa fa-angle-right']"></i>
              </div>
            </a>
            <ul v-if="menu.type == 'sub' && menu.children && menu.active" class="sidebar-submenu">
              <li v-for="(child, ci) in menu.children" :key="ci">
                <router-link :to="child.path" class="sidebar-link" v-on:click="hidesecondmenu()">
                  {{ $t(child.title) }}
                </router-link>
              </li>
            </ul>
           
            <router-link
              :to="menu.path"
              class="sidebar-link sidebar-title"
              v-if="menu.type == 'link'"
              router-link-exact-active
              exact
              v-on:click="hidesecondmenu()"
            >
              <vue-feather :type="menu.icon" class="top"></vue-feather>
              <span>
                {{ $t(menu.title) }}
              </span>
            </router-link>

            <!-- Solo para enlaces externos explícitos -->
            <a
              :href="menu.path"
              class="sidebar-link sidebar-title"
              target="_blank"
              v-else-if="menu.type == 'extLink'"
              @click="setNavActive(menu, index)"
            >
              <vue-feather :type="menu.icon" class="home"></vue-feather>
              <span class="menu1">
                {{ $t(menu.title) }}
              </span>
              <i class="fa fa-angle-right pull-right" v-if="menu.children"></i>
            </a>
          </li>
        </ul>
      </li>
    </ul>

  </div>
</template>
<script>
import navMenu from "@/mixins/navMenu";

export default {
  mixins: [navMenu],

}
</script>